module.exports = __webpack_public_path__ + "static/media/CaseySmith.e948770e.jpg";